/*! @azure/msal-browser v3.28.1 2025-01-14 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "3.28.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
